import React from "react";
import HomeControl from "components/reusable/HomeControl";
import HomeSearchContainer from "components/search/HomeSearchContainer";
import SettingsControl from "pages/create/SettingsControl";
import AccountControl from "components/account-screen/AccountControl";
import "./BracksetHeader.css";

class BracksetHeader extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            
        };

    }



    componentDidMount() {
    }



    render() {
        
        let searchSection = (<></>)
        if(!this.props.hideSearch){
            searchSection = (<div className="brackset-header-search">
                <HomeSearchContainer></HomeSearchContainer>
            </div>)
        }
        return (<>
            <div className="brackset-header-light">
                <div className="brackset-header-home">
                    <HomeControl disableFixed="true"></HomeControl>
                </div>
                {searchSection}
                <div className="brackset-header-account">
                    <AccountControl disableFixed="true" navigateHomeOnLogin={this.props.navigateHomeOnLogin}></AccountControl>
                </div>
            </div>
        </>)
    }
}

export default BracksetHeader;
